/**
 * Must match backend `src/utils/gameSlug.js` LEGACY_SLUG_BY_GAME_ID for URLs before/without API.
 */
const LEGACY_SLUG_BY_GAME_ID = {
  1: 'cs2',
  2: 'dota-2',
  3: 'league-of-legends',
  4: 'rocket-league',
};

/** Canonical slug for routing (same rules as API `resolveGameSlug`). */
export function slugForGame(game) {
  if (!game) return null;
  if (game.slug && String(game.slug).trim()) {
    return String(game.slug).trim().toLowerCase();
  }
  if (LEGACY_SLUG_BY_GAME_ID[game.gameId] != null) {
    return LEGACY_SLUG_BY_GAME_ID[game.gameId];
  }
  return `game-${game.gameId}`;
}

export function createChallengePath(game) {
  const s = slugForGame(game);
  return s ? `/create-challenge/${s}` : '/';
}
